export const getPlaylistHeightForMobile = (
  playerHeight: number,
  windowHeight: number,
  paddingTop = 25,
): number => {
  return windowHeight - paddingTop - playerHeight;
};
